import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'
import { useMsal } from "@azure/msal-react";

function Banner(props) {
    const { instance } = useMsal();

    const title = props.dimensions.x < 768 ? "Fees" : "Environmental Fees";

    const logout = async () => {
        const logoutRequest = {
            account: instance.getActiveAccount(),
            postLogoutRedirectUri: window.location.href
        };
        await instance.logoutRedirect(logoutRequest);
    };

    return (
        <header>
            <a id="logo" href="https://danr.sd.gov" target="_blank" rel='noopener noreferrer'>
                <img src="https://cdn.sd.gov/agency/DANR/DANR-Logo.png" alt="DENR" />
                <span id="danr">South Dakota Department of<br/>
                Agriculture & Natural Resources</span>
            </a>
            <div id="title">
                <span>{title}</span>
            </div>
            <div id="account">
                <div className="account-info">
                    <div className="email">{window.env.user?.emailAddress}</div>
                        {window.env.user && window.env.user.userRoles && window.env.user.userRoles.length > 0 ?
                            window.env.user.userRoles.map(ur => <div key={ur.role.roleID} className="role-name">{ur.role.roleName}</div>)
                        : null}
                </div>
                <div onClick={logout} className="action-icon action-unlink tooltip-parent">
                    <FontAwesomeIcon icon={faSignOutAlt} />
                    <div className="tooltip-target tooltip-left">
                        Logout
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Banner;